export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betmor-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betmor-themeWrapLive" */'./LiveThemeImporter'),
  },
};
